console.log(`
Do you want to reproduce my website? Look no further! 
Go directly to the source code at https://github.com/bernardomig/personal-website.
Cheers 🍻.
`)